module.exports = __webpack_public_path__ + "img/shoppingCart-btn.316b16d1.svg";